import { Box } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import _ from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cacheSelectors } from 'redux/cache.slice';
import { RootState } from 'redux/root-reducer';
import { searchParamActions, searchParamSelectors } from 'redux/search-param.slice';

const Pagination = () => {
  const dispatch = useDispatch();
  const page = useSelector((state: RootState) => searchParamSelectors.page(state));
  const rowsPP = useSelector((state: RootState) => searchParamSelectors.rowsPP(state));
  const listingsCount = useSelector((state: RootState) => cacheSelectors.listingsCount(state));
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    dispatch(searchParamActions.page(newPage));
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const rowsPerPage = +event.target.value;
    dispatch(searchParamActions.page(0));
    dispatch(searchParamActions.rowsPP(rowsPerPage));
  };
  return (
    <TablePagination
      sx={{
        '& .MuiInputBase-root': {
          marginRight: 2,
          marginLeft: 0,
        },
        '& .MuiTablePagination-actions': {
          marginLeft: 1,
        },
        '& .MuiButtonBase-root': {
          paddingRight: 0,
        },
        '& .MuiTablePagination-selectLabel': {
          // fontSize: '13px',
        },
        '& .MuiToolbar-root': {
          padding: 0,
          minHeight: 0,
        },
      }}
      component={Box}
      count={listingsCount ? listingsCount : 0}
      page={listingsCount ? page : 0}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPP}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
};

export default Pagination;
